import ResourceForm from './ResourceForm';

export * from './ResourceForm';

export default ResourceForm;
